import React, { useEffect, useContext } from "react";
import Row from "@amzn/meridian/row";
import FPHView from "../FPH/FPHView";
import ComplianceView from "../complaince/complianceView";
import { getNodeCapability } from "../handler/ParentDataHandler";
import { CapabilityContext } from "./context/CapabilityContext";
import DNCView from "../dnc/DNCView";
import { getRefreshInterval } from "./utils/utils";
import { DEFAULT_CAPABILITIES } from "../outboundAmzl/util/Constants";
import { PVAOverviewContext } from "./context/PVAOverviewContext";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../RefreshTimer";

const OverviewView = () => {
  const { capability, dispatch } = useContext(CapabilityContext);
  const { pvaData } = useContext(PVAOverviewContext);

  useEffect(() => {
    getNodeCapability().then((capabilities) => {
      dispatch({ type: "GET_CAPABILITIES", capabilities });
    });
  }, []);

  return (
    <Column spacing="small" spacingInset="medium large none large">
      <RefreshTimer deps={[pvaData]} />
      <Row widths={["grid-3", "grid-3", "grid-5"]}>
        <FPHView
          fph={{ processName: "induct", refreshRate: getRefreshInterval() }}
        />
        {DEFAULT_CAPABILITIES.includes(capability.data) ? (
          <FPHView
            fph={{ processName: "sort", refreshRate: getRefreshInterval() }}
          />
        ) : null}
        {DEFAULT_CAPABILITIES.includes(capability.data) ? (
          <DNCView
            compliance={{
              processName: "dnc",
              refreshRate: getRefreshInterval(),
            }}
          />
        ) : null}
      </Row>
      {DEFAULT_CAPABILITIES.includes(capability.data) ? (
        <Row widths={["grid-3", "grid-3", "grid-3", "grid-3"]}>
          <ComplianceView
            compliance={{
              processName: "goldilock",
              refreshRate: getRefreshInterval(),
            }}
          />
          <ComplianceView
            compliance={{
              processName: "scanCompliance",
              refreshRate: getRefreshInterval(),
            }}
          />
          <ComplianceView
            compliance={{
              processName: "rolledVolume",
              refreshRate: getRefreshInterval(),
            }}
          />
          <ComplianceView
            compliance={{
              processName: "shiftPace",
              refreshRate: getRefreshInterval(),
            }}
          />
        </Row>
      ) : null}
    </Column>
  );
};

export default OverviewView;



// WEBPACK FOOTER //
// ./src/components/overview/OverviewView.js